import { useState, useEffect, KeyboardEvent, ChangeEvent } from 'react';
import BaseTextField from './BaseTextField';
import { IconButton, SxProps, Theme } from '@mui/material';
import { Search } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

interface SearchBarProps {
    value?: string;
    onChange?: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    onSearch?: (value: string) => void;
    size?: 'small' | 'medium';
    placeholder?: string;
    error?: boolean;
    helperText?: string;
    sx?: SxProps<Theme>;
    [key: string]: any;
}

export default function SearchBar({
    value: valueProp = '',
    onChange,
    onSearch,
    size = 'medium',
    placeholder,
    error,
    helperText,
    sx,
    ...props
}: SearchBarProps) {
    const [value, setValue] = useState(valueProp);
    const { t } = useTranslation();
    useEffect(() => {
        setValue(valueProp);
    }, [valueProp]);

    const changeHandler = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setValue(e.target.value);
        onChange?.(e);
    };

    const clickHandler = () => {
        onSearch?.(value);
    };

    const keyUpHandler = (e: KeyboardEvent<any>) => {
        if (e.key === 'Enter') {
            onSearch?.(value);
        }
    };

    return (
        <BaseTextField
            size={size}
            value={value}
            placeholder={placeholder || t('Search...')}
            error={error}
            helperText={helperText}
            sx={sx}
            onChange={changeHandler}
            onKeyUp={keyUpHandler}
            endIcon={
                <IconButton type="button" aria-label="search" onClick={clickHandler}>
                    <Search />
                </IconButton>
            }
            {...props}
        />
    );
}
